import ReactGA from 'react-ga4'
import { Link } from 'react-router-dom'

export const Button = ({ edition, retailer, link, children, platform }) => {
    return (
        <>
            <button
                className={`${
                    link === 'none'
                        ? 'bg-rttcgreentint/40 text-white/70 cursor-pointer hover:duration-300 hover:ease-in-out'
                        : 'bg-rttcgreentint text-white/90 hover:bg-rttcgreen duration-300 hover:ease-in-out'
                } w-[46%] md:w-[20%] block rounded-full py-2 shadow-2xl `}
            >
                {link === 'none' ? (
                    <div>{children}</div>
                ) : (
                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'limited edition',
                                label: `${edition} Edition ${retailer} ${platform}`,
                            })
                        }}
                        className=''
                        target='_blank'
                        rel='noreferrer'
                        href={link}
                    >
                        <p className='text-sm tracking-wider text-center'>{children}</p>
                    </a>
                )}
            </button>
        </>
    )
}
export const ButtonDecoSmall = ({ children, link, gaCategory, gaLabel, onClickEvent, active }) => {
   
    return (
        <>
            <button
                onClick={
                    (() => {
                        ReactGA.event({
                            action: 'click',
                            event: 'link',
                            category: { gaCategory },
                            label: { gaLabel },
                        })
                    },
                    onClickEvent)
                }
                to={link}
                activeclassname='active'
                className={`${
                    active ? 'bg-stone-900 text-sbgrey' : 'text-sbgrey bg-stone-700'
                }  duration-500 border-white border-2 cursor-pointer relative w-[48%] lg:w-full  h-[2.8rem] lg:mr-4  hover:border-2 hover:duration-300  align-middle flex flex-wrap justify-center lg:justify-between items-center`}
            >
                <em className='not-italic whitespace-nowrap pl-2 w-auto text-base '>{children}</em>
                {active && (
                    <em>
                        <i className='hidden lg:block translate-x-full'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='12' height='18' viewBox='0 0 9 14'>
                                <path d='M7,0l7,9H0Z' transform='translate(9) rotate(90)' fill='white'></path>
                            </svg>
                        </i>
                    </em>
                )}
            </button>
        </>
    )
}
export const ButtonLine = ({ text, color, link, gaCategory, gaLabel }) => {
    return (
        <button
            className={`border-y border-${color} px-20 py-2 mb-4 relative hover:text-reygold duration-300 ease-in-out linedeco-button`}
        >
            <p className='uppercase'>
                {' '}
                <Link
                    onClick={() => {
                        ReactGA.event({
                            action: 'click',
                            event: 'link',
                            category: { gaCategory },
                            label: { gaLabel },
                        })
                    }}
                    to={link}
                    activeclassname='active'
                    className='buttonlink'
                >
                    {text}
                </Link>
            </p>
        </button>
    )
}
export const ButtonLineSmall = ({ text }) => {
    return (
        <button className={`px-12 py-2 my-4 relative linedeco-button min-w-[240px]`}>
            <h3 className='text-center text-gradient-title text-base font-pop'>{text}</h3>{' '}
        </button>
    )
}
export const ButtonRetailer = ({ dataPlatform, dataUrl, dataStore }) => {
    return (
        <button className={`retailer-button tex-sm text-left hover:brightness-150 duration-300`}>
            <a
                onClick={() => {
                    ReactGA.event({
                        action: 'click',
                        event: 'link',
                        category: 'Products',
                        label: `DE ${dataPlatform} ${dataStore}`,
                    })
                }}
                target='_blank'
                rel='noreferrer'
                href={`${dataUrl}`}
            >
                <p>{dataStore}</p>
            </a>
        </button>
    )
}
